import { gql } from '@apollo/client';

// Banderitas personales del usuario en el tenant activo.
export const GET_MY_ORDER_FLAGS = gql`
  query MyOrderFlags {
    myOrderFlags {
      orderId
      entityType
      entityId
    }
  }
`;

// Ámbito (persona o grupo) y sello de las marcas: pequeño, para saber si hay
// que descargar la lista entera.
export const GET_MY_ORDER_FLAG_SCOPE = gql`
  query GetMyOrderFlagScope {
    myOrderFlagScope {
      kind
      groupId
      groupName
      stamp
    }
  }
`;
